import React from 'react';
import { Ads } from '../Ads';
import { Inner } from '../partials';
export var BottomAds = function BottomAds(_ref) {
  var path = _ref.path,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin,
    _ref$sticky = _ref.sticky,
    sticky = _ref$sticky === void 0 ? false : _ref$sticky,
    _ref$fixed = _ref.fixed,
    fixed = _ref$fixed === void 0 ? false : _ref$fixed,
    _ref$targeting = _ref.targeting,
    targeting = _ref$targeting === void 0 ? {} : _ref$targeting,
    _ref$closeable = _ref.closeable,
    closeable = _ref$closeable === void 0 ? false : _ref$closeable,
    _ref$disableAutorefre = _ref.disableAutorefresh,
    disableAutorefresh = _ref$disableAutorefre === void 0 ? false : _ref$disableAutorefre,
    responsive = _ref.responsive;
  if (typeof window === 'undefined') return null;
  return React.createElement(Inner, {
    bottomMargin: bottomMargin,
    sticky: sticky,
    fixed: fixed
  }, React.createElement(Ads, {
    id: path,
    targeting: targeting,
    closeable: closeable,
    responsive: responsive,
    autorefresh: typeof disableAutorefresh === 'undefined' ? undefined : !disableAutorefresh
  }));
};